import { apiService } from './apiService';

export const archiveService = {
  async getAll() {
    return await apiService.get('/archives');
  },

  async getNextCode() {
    return await apiService.get('/archives/next-code');
  },

  async getNextFolderNumber(startFrom?: string | number | null) {
    const query = startFrom ? `?startFrom=${encodeURIComponent(String(startFrom))}` : '';
    return await apiService.get(`/archives/next-folder-number${query}`);
  },

  async create(data: { shipmentId: string; folderName?: string; evrakSiraNo?: string; invoiceNumber?: string; hasFuelPurchase?: boolean; folderNumber?: number | string }) {
    return await apiService.post('/archives', data);
  },

  async update(id: string, data: { folderName?: string; evrakSiraNo?: string; invoiceNumber?: string; hasFuelPurchase?: boolean; folderNumber?: number | string }) {
    return await apiService.put(`/archives/${id}`, data);
  },

  async restore(shipmentId: string) {
    return await apiService.post(`/archives/restore/${shipmentId}`, {});
  },

  async checkArchive(shipmentId: string) {
    return await apiService.get(`/archives/check/${shipmentId}`);
  },
};
